import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class ErrorlogService extends RestfulService<Models.Error> {

  constructor(public restService: RestService) {
    super(Models.Error);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('errors');
  }

}
